import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Manifesto } from "../components/site/Manifesto";
import { Process } from "../components/site/Process";
import { LeadsShowcase } from "../components/site/LeadsShowcase";
import { Sectors } from "../components/site/Sectors";
import { CaseStudies } from "../components/site/CaseStudies";
import { ConsultForm } from "../components/site/ConsultForm";
import { useSeo } from "../components/site/Seo";
import { scrollToId } from "../lib/smooth";
import { api } from "../lib/api";

export default function Home({ cases = [] }) {
  const { hash } = useLocation();
  useSeo();
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 350);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <main data-testid="home-page">
      <Hero />
      <Marquee />
      <Manifesto />
      <Process />
      <LeadsShowcase />
      <Sectors />
      <CaseStudies cases={cases} />
      <ConsultForm />
    </main>
  );
}

export const useCases = () => {
  const [cases, setCases] = useState([]);
  useEffect(() => {
    let alive = true;
    api.get("/case-studies")
      .then((r) => { if (alive) setCases(Array.isArray(r?.data) ? r.data : []); })
      .catch(() => {});
    return () => { alive = false; };
  }, []);
  return cases;
};
